import React, { useRef } from "react";

import Header from "./Header";
import Footer from "./Footer";

import {
  FaRobot,
  FaBrain,
  FaMicrochip,
  FaGlobe
} from "react-icons/fa";

import "./Styles.css";

export default function UpcomingProducts() {

  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);

  const upcomingProducts = [
    {
      icon: <FaRobot />,
      title: "AI Assistant",
      desc:
        "A next-generation AI assistant designed to automate tasks, enhance productivity, and simplify daily workflows.",
      status: "Coming Soon",
    },

    {
      icon: <FaBrain />,
      title: "Emotion AI",
      desc:
        "AI capable of understanding emotions, tone, and intent to create more human-like interactions.",
      status: "In Research",
    },

    {
      icon: <FaMicrochip />,
      title: "Smart AI Devices",
      desc:
        "AI-powered smart ecosystem integrating hardware and software for seamless intelligent experiences.",
      status: "Prototype",
    },

    {
      icon: <FaGlobe />,
      title: "Global AI Platform",
      desc:
        "A multilingual AI communication platform connecting people worldwide through intelligent interactions.",
      status: "Development",
    },
  ];

  return (
    <div
      style={{
        background: "#020617",
        minHeight: "100vh",
      }}
    >

      {/* HEADER */}
      <Header
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef
        }}
      />

      {/* PAGE */}
      <div className="products-page">

        {/* TOP */}
        <div className="products-header">

          <p className="products-tag">
            UPCOMING PRODUCTS
          </p>

          <h1 className="products-title">
            The future we're building
          </h1>

          <p className="products-subtitle">
            Explore the next generation of AI-powered innovations
            currently being designed and developed at Neomonks.
          </p>

        </div>

        {/* CARDS */}
        <div className="products-grid">

          {upcomingProducts.map((item, index) => (

            <div
              key={index}
              className="product-card"
            >

              <div className="product-icon">
                {item.icon}
              </div>

              <div className="product-status">
                {item.status}
              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

            </div>

          ))}

        </div>

      </div>

      {/* FOOTER */}
      <Footer
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef
        }}
      />

    </div>
  );
}